/**
 * Privacy Screen
 * 
 * Loads the UserPreferences MFE with /privacy path for privacy settings.
 * 
 * @module components/menu/PrivacyScreen
 */

import React from 'react';
import { MFELoader } from '@/components/mfe/MFELoader';
import { useAuth } from '@/contexts/AuthContext';
import { CommunicationBridge } from '@sequelae/lore-mfe-kit';

export const PrivacyScreen: React.FC = () => {
  const { user, logout } = useAuth();
  const token = CommunicationBridge.getAccessToken();

  if (!token || !user) {
    return <div>Unauthorized</div>;
  }

  return (
    <MFELoader
      mfeName="UserPreferences"
      accessToken={token}
      refUserId={user.id}
      onLogout={logout}
      initialPath="/privacy"
      onError={(err) => {
        console.error('[PrivacyScreen] MFE Load Error:', err);
      }}
    />
  );
};

